// extracted by mini-css-extract-plugin
export default {"container_products":"style_container_products__UxWVs","products_list":"style_products_list__T-B5s","filter_text":"style_filter_text__G02J4"};